import React from 'react';
import { Link } from 'react-router-dom';
import { BsArrowLeft } from "react-icons/bs";

const HeadSection = () => {
    return (
        <>
            <section className="head__area">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <Link to="/" className="z-btn"><i><BsArrowLeft /></i> Back</Link>
                            <div className="section__title">
                                <h2 className="font500">Features</h2>
                                <span>A single platform for analysis from planning to operations of NetZero</span>
                            </div>
                            <div className="imgBox m-img">
                                <img src="assets/img/features-img1.png" alt="Dsider" />
                            </div>
                            <div className="iconArea">
                                <div className="iconBox">
                                    <img src="assets/img/home-icon9.png" alt="Dsider" />
                                </div>
                                <div className="iconBox one">
                                    <img src="assets/img/home-icon10.png" alt="Dsider" />
                                </div>
                                <div className="iconBox two">
                                    <img src="assets/img/home-icon11.png" alt="Dsider" />
                                </div>
                                <div className="iconBox three">
                                    <img src="assets/img/home-icon12.png" alt="Dsider" />
                                </div>
                                <div className="iconBox four">
                                    <img src="assets/img/home-icon14.png" alt="Dsider" />
                                </div>
                                <div className="iconBox five">
                                    <img src="assets/img/home-icon15.png" alt="Dsider" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default HeadSection;